import React, { PropsWithChildren, useEffect, useState } from 'react';
import { QueryCache, useQueryClient, QueryObserver } from '@tanstack/react-query';
import { QueryStatusContext } from './QueryStatusProvider.context';

type QueryStatusProviderProps = PropsWithChildren<{}>;

const QueryStatusProvider = ({ children }: QueryStatusProviderProps) => {
  const [queryStatuses, setQueryStatuses] = useState({});
  const queryClient = useQueryClient();
  const observer = new QueryObserver(queryClient, { queryKey: ['observer'] })
  //const queryCache = new QueryCache();
  useEffect(() => {
    //const unsubscribe = 
    // queryCache.subscribe((e, query) => {
    //   query &&
    //     setQueryStatuses((pre) => ({
    //       ...pre,
    //       [query?.queryHash]: query?.state.status,
    //     }));
    // });
    //return unsubscribe;
  

  const unsubscribe = observer.subscribe(queryResult => {
    queryResult &&
      setQueryStatuses((pre) => ({
        ...pre,
        ['observer']: queryResult?.status,
      }));
  },);
  return unsubscribe;
  }, []);
  return (
    <QueryStatusContext.Provider value={queryStatuses}>
      {children}
    </QueryStatusContext.Provider>
  );
};

export default QueryStatusProvider;
